import React from 'react';
import Features from '../HomePages/components/Features';
import Team from './Team';
import Timeline from './Timeline';

export default function AboutPage() {
  return (
    <>
      <section className="text-center py-12 bg-white">
        <h1 className="text-4xl md:text-5xl font-bold text-[var(--color-primary)] mb-4">Biz Kimiz?</h1>
        <p className="text-lg md:text-xl text-[var(--color-black)] max-w-2xl mx-auto mb-8">
          SolarTools, yenilenebilir enerji ve dijital dönüşüm alanında uzmanlaşmış bir ekipten oluşur. Amacımız, fabrikalar ve tesisler için kullanıcı dostu, özelleştirilebilir ve modern dashboard çözümleri sunmaktır. Teknolojimizle enerji verimliliğini artırıyor, sürdürülebilirliği destekliyoruz.
        </p>
      </section>
      <Timeline />
      <Team />
    </>
  );
} 